import React from "react";

const ConsentModal = ({ show, onAgree, onDisagree }) => {
  if (!show) return null;
  return (
    <div
      style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(0,0,0,0.5)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <div style={{
        background: "#fff",
        borderRadius: "1rem",
        padding: "2rem",
        maxWidth: 400,
        boxShadow: "0 4px 24px rgba(0,0,0,0.15)"
      }}>
        <h4>VoiceLoop Policy Consent</h4>
        <p>
          To use VoiceLoop, you must agree to our{" "}
          <a href="/policy" target="_blank" rel="noopener noreferrer">policy</a>.<br />
          Audio you record will be sent to OpenAI for transcription and refinement. We do not store your audio or transcripts after processing.
        </p>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "1.5rem", marginTop: "1.5rem" }}>
          <span
            style={{ color: "#2563eb", cursor: "pointer", textDecoration: "underline" }}
            onClick={onAgree}
            tabIndex={0}
            role="button"
          >
            I Agree
          </span>
          <span
            style={{ color: "#64748b", cursor: "pointer", textDecoration: "underline" }}
            onClick={onDisagree}
            tabIndex={0}
            role="button"
          >
            I Disagree
          </span>
        </div>
      </div>
    </div>
  );
};

export default ConsentModal;